export type DocumentType =
  | "passport_main"
  | "passport_registration"
  | "passport_main_registration_combined"
  | "foreign_passport_file"
  | "residence_permit_file"
  | "temporary_residence_permit_file"
  | "migration_card_file"
  | "arrival_notification_file"
  | "foreign_id_card_file"
  | "offer_file"
  | "document_agreement1_file_id"
  | "prices_tariffs_file"
  | "education_certificate";

export type DocumentFieldName =
  | "passport_main_file_id"
  | "passport_registration_file_id"
  | "passport_main_registration_combined_file_id"
  | "foreign_passport_file_id"
  | "residence_permit_file_id"
  | "temporary_residence_permit_file_id"
  | "migration_card_file_id"
  | "arrival_notification_file_id"
  | "foreign_id_card_file_id"
  | "offer_file_id"
  | "document_agreement1_file_id"
  | "prices_tariffs_file_id"
  | "education_certificate_file_id";

export const DOCUMENT_TYPE_TO_FIELD_MAP: Record<DocumentType, DocumentFieldName> = {
  passport_main: "passport_main_file_id",
  passport_registration: "passport_registration_file_id",
  passport_main_registration_combined: "passport_main_registration_combined_file_id",
  foreign_passport_file: "foreign_passport_file_id",
  residence_permit_file: "residence_permit_file_id",
  temporary_residence_permit_file: "temporary_residence_permit_file_id",
  migration_card_file: "migration_card_file_id",
  arrival_notification_file: "arrival_notification_file_id",
  foreign_id_card_file: "foreign_id_card_file_id",
  offer_file: "offer_file_id",
  document_agreement1_file_id: "document_agreement1_file_id",
  prices_tariffs_file: "prices_tariffs_file_id",
  education_certificate: "education_certificate_file_id"
};

export const DOCUMENT_FIELD_NAMES: DocumentFieldName[] = [
  "passport_main_file_id",
  "passport_registration_file_id",
  "passport_main_registration_combined_file_id",
  "foreign_passport_file_id",
  "residence_permit_file_id",
  "temporary_residence_permit_file_id",
  "migration_card_file_id",
  "arrival_notification_file_id",
  "foreign_id_card_file_id",
  "offer_file_id",
  "document_agreement1_file_id",
  "prices_tariffs_file_id",
  "education_certificate_file_id"
];

export const getDocumentFieldName = (type: DocumentType): DocumentFieldName => {
  return DOCUMENT_TYPE_TO_FIELD_MAP[type];
};

// Значения file_type, которые принимает POST /api/questionnaire/v1/helper/file на бэкенде.
// Для offer_file бэкенд-аналога пока нет — файл оферты грузится отдельным эндпоинтом.
export type BackendFileType =
  | "logo_main"
  | "document_additional1"
  | "document_additional2"
  | "document_agreement1"
  | "document_agreement2"
  | "prices_tariffs"
  | "document_agreement"
  | "partner_statement"
  | "passport_main"
  | "passport_registration"
  | "foreign_passport_rf"
  | "residence_permit"
  | "temporary_residence_permit"
  | "id_card"
  | "place_of_stay"
  | "migration_card"
  | "education_certificate";

export const DOCUMENT_TYPE_TO_BACKEND_FILE_TYPE: Partial<Record<DocumentType, BackendFileType>> = {
  passport_main: "passport_main",
  passport_registration: "passport_registration",
  // У бэкенда пока нет отдельного file_type для "разворот + регистрация одним файлом",
  // поэтому такой файл размечается как основной разворот паспорта.
  passport_main_registration_combined: "passport_main",
  foreign_passport_file: "foreign_passport_rf",
  residence_permit_file: "residence_permit",
  temporary_residence_permit_file: "temporary_residence_permit",
  migration_card_file: "migration_card",
  arrival_notification_file: "place_of_stay",
  foreign_id_card_file: "id_card",
  document_agreement1_file_id: "document_agreement1",
  prices_tariffs_file: "prices_tariffs",
  education_certificate: "education_certificate"
};

export const getBackendFileType = (type: DocumentType): BackendFileType | undefined =>
  DOCUMENT_TYPE_TO_BACKEND_FILE_TYPE[type];

// Типы документов, удостоверяющих личность — к ним применяется более строгая валидация
// на бэкенде: только изображения/PDF, размер 10 Kb – 5 Mb, габариты фото 300–8000 px.
export const IDENTITY_DOCUMENT_TYPES: DocumentType[] = [
  "passport_main",
  "passport_registration",
  "passport_main_registration_combined",
  "foreign_passport_file",
  "residence_permit_file",
  "temporary_residence_permit_file",
  "migration_card_file",
  "arrival_notification_file",
  "foreign_id_card_file"
];

export const isIdentityDocumentType = (type: DocumentType): boolean =>
  IDENTITY_DOCUMENT_TYPES.includes(type);

export const NON_IDENTITY_TYPES_WITH_IDENTITY_VALIDATION: DocumentType[] = [
  "education_certificate"
];

export const usesIdentityFileValidation = (type: DocumentType): boolean =>
  isIdentityDocumentType(type) || NON_IDENTITY_TYPES_WITH_IDENTITY_VALIDATION.includes(type);

export const URL_MAX = "https://max.ru/id1215156909_bot";
export const URL_MAIL = "mailto:connection@prodamus.ru";
export const URL_PRODAMUS = "https://prodamus.ru/";
